import { render, staticRenderFns } from "./AddAssetsDialog.vue?vue&type=template&id=a9b81a46&"
import script from "./AddAssetsDialog.vue?vue&type=script&lang=ts&"
export * from "./AddAssetsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports